import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'whatwg-fetch'
import { isEdge } from '@braintree/browser-detection'
import {
  initializeVideoThumbnails,
  initializeVideoDescriptions,
  initializeVideos,
  initializeVideoThumbnail,
  initializeVideoDescription,
  initializeVideo,
} from '../lib/proxy/videos'
import { initializeAudios, initializeAudio } from '../lib/proxy/audios'
import { initializeEpub } from '../lib/proxy/epub'
import { initializeNativeVideos, initializeNativeVideo } from '../lib/proxy/native_videos'

declare global {
  interface Window {
    SkyPilot?: Record<string, unknown>
    hideDownloadWarning: (element: HTMLElement) => void
  }
  interface Document {
    sky_pilot_skip_video_initialization?: boolean
  }
}

initializeVideoThumbnails()
initializeVideoDescriptions()
initializeAudios()
initializeNativeVideos()

document.querySelectorAll<HTMLElement>('.sky-pilot-embed-description-remote').forEach((el) => {
  initializeVideoDescription(el)
})

if (typeof document.sky_pilot_skip_video_initialization === 'undefined') {
  initializeVideos()
}

const Api = {
  initializeVideo,
  initializeVideoDescription,
  initializeVideoThumbnail,
  initializeVideos,
  initializeVideoDescriptions,
  initializeVideoThumbnails,
  initializeAudios,
  initializeAudio,
  initializeEpub,
  initializeNativeVideos,
  initializeNativeVideo,
  initialize_vimeo_video: (element: HTMLElement) => {
    console.warn(
      'Depricated: SkyPilot.initialize_vimeo_video(element) is depricated and will be removed.  Please use SkyPilot.initializeVideo(element) instead'
    )
    initializeVideo(element)
  },
  initialize_vimeo_thumbnail: (element: HTMLElement) => {
    console.warn(
      'Depricated: SkyPilot.initialize_vimeo_video(element) is depricated and will be removed.  Please use SkyPilot.initializeVideo(element) instead'
    )
    initializeVideoThumbnail(element)
  },
  initialize_vimeo_description: (element: HTMLElement) => {
    console.warn(
      'Depricated: SkyPilot.initialize_vimeo_video(element) is depricated and will be removed.  Please use SkyPilot.initializeVideo(element) instead'
    )
    initializeVideoDescription(element)
  },
}

function displayDownloadWarning(elementToAdd: string) {
  document.querySelectorAll<HTMLElement>('div.sky-pilot-actions > a.sky-pilot-button').forEach((el) => {
    el.onclick = () => {
      let content = <HTMLElement | null | undefined>el.closest('.sky-pilot-list-item')
      if (!content) content = el.closest('.sky-pilot-actions')?.parentElement
      if (content && !content.classList.contains('has-download-warning')) content.innerHTML = elementToAdd + content?.innerHTML
      if (content) content.classList.add('has-download-warning')
    }
  })
}

export const hideDownloadWarning = (el?: HTMLElement) => {
  el?.closest('.has-download-warning')?.classList?.remove('has-download-warning')
  el?.closest('.download-warning')?.remove()
}
window.hideDownloadWarning = hideDownloadWarning

if (isEdge()) {
  const toAdd = `
    <div style="background-color: rgba(233, 213, 2, 0.5);margin-top:10px;border-radius:5px;" class="sky-pilot-file-wrapper download-warning">
      <div class="sky-pilot-file-actions" style="padding-left:20px;">
        <b>Download didn&lsquo;t work? Microsoft Edge</b> can falsely flag files as dangerous and block the download. Use option "Keep" in the Downloads menu or use another browser to get the file, all of our files are absolutely safe!
      </div>
      <div class="sky-pilot-actions" style="padding: 0 20px;cursor:pointer;" onclick="hideDownloadWarning(this)">&#x2715</div>
    </div>`
  displayDownloadWarning(toAdd)
}

const navigator = window.navigator
const userAgent = navigator.userAgent
const normalizedUserAgent = userAgent.toLowerCase()
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const standalone = (navigator as any).standalone

const isIos = /ip(ad|hone|od)/.test(normalizedUserAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
const isAndroid = /android/.test(normalizedUserAgent)
const isSafari = /safari/.test(normalizedUserAgent)
const isWebview = (isAndroid && /; wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari)
if (isWebview) {
  const toAdd = `
      <div style="background-color: rgba(233, 213, 2, 0.5);margin-top:10px;border-radius:5px;" class="sky-pilot-file-wrapper download-warning">
        <div class="sky-pilot-file-actions" style="padding-left:20px;">
          <b>Download didn&lsquo;t work? Some apps such as Instagram block file downloads! Use option "Share" and "Open in external browser" to get your files.
        </div>
        <div class="sky-pilot-actions" style="padding: 0 20px;cursor:pointer;" onclick="hideDownloadWarning(this)">&#x2715</div>
      </div>
      `
  displayDownloadWarning(toAdd)
}

window.SkyPilot =
  typeof window.SkyPilot === 'undefined'
    ? Api
    : {
        ...window.SkyPilot,
        ...Api,
      }
